import React, { useMemo } from "react";
import { FieldValues } from "react-hook-form";
import FingridTestGenericPlanningsForm from "../shared/FingridTestGenericPlanningsForm";
import { computeDefaultValuesFcrD, fcrDPlanningConfigurations } from "./config";

export interface PlanningFormProps {
  initialData: FieldValues;
}

const TestFcrDPlanningsForm: React.FC<PlanningFormProps> = ({ initialData }) => {
  const defaultValues = useMemo(() => computeDefaultValuesFcrD(initialData), [initialData]);

  return (
    <FingridTestGenericPlanningsForm
      initialData={initialData}
      configs={fcrDPlanningConfigurations}
      defaultValues={defaultValues}
      lockSocEndDate
    />
  );
};

export default TestFcrDPlanningsForm;
